module.exports = __webpack_public_path__ + "assets/img/not_menu.b7270392.png";